import { Controller } from "@hotwired/stimulus"

// フォーム内の入力変更で即フォーム送信する。
// <form data-controller="auto-submit" data-action="change->auto-submit#submit"> に付ける。
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
